var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.8c-1.6 0-3.2.2-4.8.8H11l2.4 11.2c-.6.6-.8 1.4-.8 2.2 0 1.8 1.4 3.4 3.4 3.4q.9 0 1.8-.6l4.4 1.8 1.6-3.6-4.4-1.8c-.2-1-1-1.8-2-2.4l-1.8-7.2h.2c5.8 0 10.4 4.8 10.4 10.4 0 5.8-4.8 10.4-10.4 10.4C10 26.4 5.4 21.6 5.4 16c0-3.2 1.4-6 3.8-8L7.6 4.3c-3.6 2.6-6 6.8-6 11.6C1.6 23.8 8 30.4 16 30.4S30.4 24 30.4 15.9c0-7.8-6.6-14.1-14.4-14.1"
  })));
};
export default SvgClock;